module.exports = __webpack_public_path__ + "static/img/6.192b316.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/6.jpg
// module id = DeB9
// module chunks = 0